import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  INavigationService,
  NAVIGATION_LOADER_SERVICE,
  NavigationDropdown,
  NavigationItem,
  NavigationLink,
  NavigationSubheading
} from '@pharvio/core/ui';

@Injectable()
export class NavigationService implements INavigationService {
  private readonly loader = inject(NAVIGATION_LOADER_SERVICE);

  items$: Observable<NavigationItem[]> = this.loader.items$;

  private readonly _openChange = new Subject<NavigationDropdown>();
  openChange$ = this._openChange.asObservable();

  triggerOpenChange(item: NavigationDropdown): void {
    this._openChange.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }
}
